import { Component, Input, DestroyRef, OnInit, ViewChild, inject } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { first } from 'rxjs/operators';
import * as DialogActions from 'app/dialog/features/dialog.actions';
import { SharedService } from 'app/virtual-event/services/shared.service';
import { loadEditCampaignList, resetCamapign, setStatusCamapign } from '../../features/campaign.actions';
import { CAMPAIGN_TYPE  } from 'app/virtual-event/virtual-event.enums';
import { resetVEvent } from 'app/event/features/event.actions';
import { MdbPopoverDirective } from 'mdb-angular-ui-kit/popover';
import { PopoverService } from 'app/core/services/popover.service';
import { Router } from '@angular/router';
import { TicketingSchema } from '../../structure/ticketing';
import { UntypedFormBuilder } from '@angular/forms';
import { CampaignFormService, CampaignService } from '../../services';
import { RaffleDrawComponent } from 'app/core/components/modals/raffle-draw/raffle-draw.component';
import { MdbModalRef, MdbModalService } from 'mdb-angular-ui-kit/modal';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

let id = 1;
@Component({
  selector: 'app-actions-popover-campaign',
  templateUrl: './actions-popover-campaign.component.html',
  styleUrls: ['./actions-popover-campaign.component.scss']
})
export class ActionsPopoverCampaignComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  @ViewChild('popover') popover: MdbPopoverDirective = null;

  @Input() campaign:any = null
  @Input() event:any = null

  private _id = id++;
  get id() {
    return `ActionsPopoverCampaign_${this._id}`;
  }

  public CAMPAIGN_TYPE = CAMPAIGN_TYPE;
  public isProduction = false;
  public showDrawWinner: boolean = false;
  modalRef: MdbModalRef<RaffleDrawComponent> | null = null;

  constructor(
    private store: Store,
    private popoverService: PopoverService,
    private sharedService: SharedService,
    private router: Router,
    private fb: UntypedFormBuilder,
    private campaignFormService: CampaignFormService,
    private modalService: MdbModalService,
    private campaignService: CampaignService,
  ) { 
      this.isProduction = window['isProduction'];
  }

  ngOnInit(): void {
    this.showDrawWinner = this.campaign.type === CAMPAIGN_TYPE.TICKETING && this.campaign.campaignTypeData.isRaffleTicket;
  }

  onPopoverShown(): void {
    this.popoverService.list[this.id] = this.popover;
  }

  onPopoverHidden(): void {
    delete this.popoverService.list[this.id];
  }

  generateConfirmAction(name, initialState) {
    return DialogActions.openDialog({
      payload: {
        name,
        options: {
          size: 'small',
          modalClass:'modal--paybee modal-sm',
          containerClass:'mdb-modal-backdrop-paybee',
          ignoreBackdropClick: true
        },
        initialState
      }
    });
  }

  onClickReport(campaign) {
    let type = window['orgMain'].campaignTypeMap[campaign.type]
    this.router.navigateByUrl(`/reports/campaign/paid/${type}/${campaign.id}`)
  }

  resetAuctionData(campaign) {
    const resetAuctionDataAction = this.generateConfirmAction("confirmResetAuctionData", {
      campaign,
      text: "This action will reset all campaign data",
      callback: (result) => {
        if(result) {
          this.store.dispatch({
            type: resetCamapign.type,
            payload: campaign.id
          });
        }
      }
    });
    this.store.dispatch(resetAuctionDataAction);
  }

  clearLastHeroWinner(campaign) {
    const clearLastHeroWinnerAction = this.generateConfirmAction("confirmClearLastHeroWinner", {
      campaign,
      text: "This action will reset all campaign data",
      callback: (result) => {
        if(result) {
          this.store.dispatch({
            type: resetCamapign.type,
            payload: campaign.id
          });
        }
      }
    });
    this.store.dispatch(clearLastHeroWinnerAction);
  }

  onClickCopyAuction(campaign) {
    const action: Action = DialogActions.openDialog({
      payload: {
        name: 'copyCampaign',
        options: {
          size: 'large',
          modalClass:'modal--paybee modal-lg',
          containerClass:'mdb-modal-backdrop-paybee',
        },
        initialState: {
          campaign
        }
      }
    });
    this.store.dispatch(action);
  }

  onClickCopy(campaign) {
    window['cloneCallbackSubject'] = new Subject();
    window['orgMain'].cloneCallback.call(campaign);
    window['cloneCallbackSubject'].pipe(
      first(),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(() => {
      this.store.dispatch({
        type: loadEditCampaignList.type,
        payload: this.sharedService.token
      });
    })
  }

  onClickRaffleDraw(campaign) {
    this.campaignService.raffleDraw(campaign.id)
    .pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((data:any)=>{
      let isArray = false
      if(Array.isArray(data)){
        isArray = true
      }
      this.modalRef = this.modalService.open(RaffleDrawComponent, {
        ignoreBackdropClick: false,
        modalClass:`modal--paybee ${ isArray ? 'modal-lg' : ''}`,
        containerClass:'mdb-modal-backdrop-paybee',
        data: {
          isArray,
          data,
          campaign,
          onClose: ()=>{
            this.modalRef.close()
          }
        }
      });
    })

  }

  hasBasketRaffle(campaign) {
    const { campaignTypeData } = campaign;
    return (campaign.type === CAMPAIGN_TYPE.TICKETING &&
      !(campaignTypeData.basketRaffle
      || campaignTypeData.isTicketForInPersonEvent
      || campaignTypeData.isTicketForVirtualEvent
      || campaignTypeData.hasOwnProperty("linkedEventId")
      || campaignTypeData.hasOwnProperty("linkedVirtualEventID"))
    ) ? true: false;
  }

  archiveCampaign(campaign) {
    const archiveCampaignAction = this.generateConfirmAction("confirmArchiveCampaign", {
      campaign,
      modalTitle: "Confirm Archive?",
      text: "All past transactions and reports will work for these campaigns but they will not be available in various dropdowns for manage etc.",
      buttonCancel: "No",
      buttonConfirm: "Yes",
      callback: (result) => {
        if(result) {
          this.store.dispatch({
            type: setStatusCamapign.type,
            payload: { campaignId: campaign.id, newStatus: 5 }
          });
        }
      }
    });
    this.store.dispatch(archiveCampaignAction);
  }

  onClickInvite(campaign) {
    window['orgMain'].showInviteTicketingModal(campaign, false);
  }

  onClickResetData(event) {
    const resetDataAction = this.generateConfirmAction("confirmResetAuctionData", {
      event,
      text: "This action will reset all event data",
      callback: (result) => {
        if(result == false) {
          return false;
        }

        let id = null;
        switch(event.type) {
          case 1:
            id = event.virtualEventInfo.id;
            break;
          case 2:
            id = event.hybridEventInfo.virtualEvent.id;
            break;
        }
        this.store.dispatch({
          type: resetVEvent.type,
          payload: id
        });
      }
    });
    this.store.dispatch(resetDataAction);
  }
}
